import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap");

 * {
    box-sizing: border-box;
    outline-color: #727272;
  }

 html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body, button, input, textarea {

    --orange: #ff5824;
    --black: #222222;
    --white: #fff;
    --purple: #871ae5;
    --dark-gray: #555555;
    --medium-gray: #727272;
    --border-gray: #dddddd;
    --line-gray: #eeeeee;
    --light-bg: #fafafa;
    --green: #06c678;
    --red: #ed0000;

    background: #ffffff;
    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 100%;
    color: var(--black);
    line-height: 1.333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

  }

  button {
    cursor: pointer;
    appearance: none;
  }

  h1, h2, h3, h4 {
    font-family: 'Inter';
  }

  p, li {
    font-size: 16px;
    line-height: 28px;
  }

  a {
    text-decoration: none;
    color: var(--black)
  }

  ol, ul, li {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  img {
    display: block;
  	width: 100%;
  	height: auto;
  }

  #hs-eu-cookie-confirmation-inner {
    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";

    padding: 16px 24px;
    font-size: 14px;
    line-height: 24px;

    #hs-eu-policy-wording {
      a {
        color: var(--orange)!important;
        font-weight: bold;
      }
    }

    #hs-en-cookie-confirmation-buttons-area {
      a {
        margin-right: 0;
        border-radius: 4px;
      }
    }

    p {
      color: var(--dark-gray)!important;
    }


    @media screen and (max-width: 768px) {
      position: fixed;
      top: 0;
      box-shadow: 0px 9px 15px rgba(0,0,0,0.05);

      line-height: 20px;
    }
  }

  #hs-category-analytics-unchecked, 
  #hs-category-advertisement-unchecked, 
  #hs-category-functionality-unchecked, 
  a#hs-eu-decline-button {
    display:none
  }
  
  div#hs-eu-cookie-confirmation 
  div#hs-eu-cookie-confirmation-inner 
  a#hs-eu-decline-button {
  	display: none !important
  }
  
  div#hs-eu-cookie-confirmation 
  div#hs-eu-cookie-confirmation-inner {
  	display: grid;
	grid-template-columns: 2fr 1fr;
  }
  
  div#hs-eu-cookie-confirmation 
  div#hs-eu-cookie-confirmation-inner 
  div#hs-eu-policy-wording {
  	display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0 !important;
  }
  
  div#hs-eu-cookie-confirmation 
  div#hs-eu-cookie-confirmation-inner p {
  	margin: 0 10px !important;
  }
  
  div#hs-eu-cookie-confirmation 
  div#hs-eu-cookie-confirmation-inner 
  div#hs-en-cookie-confirmation-buttons-area {
  	width: 100%;
    margin-right: 0 !important;
	justify-content: flex-end !important;
  }
  
  div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner p a {
  	color: #ff5824 !important;
    text-decoration: underline !important;
  }
  
  @media only screen and (max-width: 600px) {
      div#hs-eu-cookie-confirmation 
      div#hs-eu-cookie-confirmation-inner p {
        padding-top: 12px;
      }
    
    div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-en-cookie-confirmation-buttons-area {
    	justify-content:center !important;
      	width: 100%;
      	
    }
    
    div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-en-cookie-confirmation-buttons-area, div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-eu-cookie-confirmation-button-group {
    	width: 100%;
    }
    
    div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner a, div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner a#hs-eu-confirmation-button {
    	width: 100%;
    	text-align: center !important;
    }
    
    div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-en-cookie-confirmation-buttons-area, div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-eu-cookie-confirmation-button-group {
    	flex-direction: column !important;
      	flex-wrap: initial !important;
    }
  }


div.UISection__ScrollWrapper-uwejuo-0 {
      background-color: pink;
      padding: 20px;
    }


`;

export default GlobalStyles;
